import { ARCHIVED_NOTICE } from '../../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import styles from './ArchiveNotice.module.css';

interface Props {
    lang: MultiLang;
}

/** The archive notice shown prominently on the top page. */
const ArchiveNotice = (props: Props) => {
    const { lang } = props;
    return (
        <div className={styles.notice} role="note">
            <svg className={styles.icon} viewBox="0 0 20 20" aria-hidden="true">
                <circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
                <rect x="9" y="8.5" width="2" height="6" fill="currentColor" />
                <rect x="9" y="5" width="2" height="2" fill="currentColor" />
            </svg>
            <p className={styles.text}>{Functions.mlang(ARCHIVED_NOTICE, lang)}</p>
        </div>
    );
};

export default ArchiveNotice;
